<template>
	<div class="d-flex flex-grow-1 overflow-hidden my-2">
		<assign-user />
	</div>
</template>
<script>
import AssignUser from './AssignUser.vue';
export default {
	name: 'InventoryFormAssignUsers',
	data() {
		return {};
	},
	components: { AssignUser },
};
</script>
